<div *ngIf="project">
    <ng-select [closeOnSelect]="true"
               [items]="project.workorders"
               [clearable]="false"
               [(ngModel)]="workorder"
               bindLabel="id_4ps"
               class="ng-select-workorder"
               (ngModelChange)="workorderChange($event.id)"
               placeholder="Werkopdracht">
        <ng-template ng-option-tmp let-item="item" let-index="index">
            {{item.planned_startdate | codaltDate : 'EE d MMM \'\'yy H:mm'}}
            &middot;
            {{item.soort | lowercase}}
            <br>
            <small>
                {{item.id_4ps}}
                &middot;
                {{item.description}}
            </small>
        </ng-template>
    </ng-select>
</div>
<div *ngIf="workorder" class="flex-fill">
    <div class="mb-3">
        <h4 class="mb-1"><i class="fa-solid fa-arrow-up-right-from-square me-1"
                            routerLink="/{{Routenames.WorkOrders}}"
                            [queryParams]="{workorderId: workorder.id}"
                            style="cursor: pointer;" matTooltip="Open details werkopdracht"></i>{{workorder.soort}}</h4>
        {{workorder.planned_startdate | codaltDate : 'EEEE d MMM yyyy H:mm' : workorder.planned_enddate}}<br>
        <small>{{workorder.description}}</small>
    </div>
    <b>Medewerkers</b><br/>
    <ul *ngIf="workorder?.users">
        <li *ngFor="let user of workorder.users">{{user.name}}</li>
    </ul>

    <div *ngIf="ttmTypes" class="pb-3">
        <table>
            <th colspan="2">
                Toegevoegde maatregelen
            </th>
            <tr *ngIf="!includedTtms?.length">
                <td colspan="2">
                    <i>Geen maatregelen toegevoegd</i>
                </td>
            </tr>

            @for (type of ttmTypes | presentTtmTypes : includedTtms : includedTtms?.length; track type.key) {
                <tr>
                    <td class="pe-2">
                        {{type.name}}
                    </td>
                    <td>
                        ({{includedTtms | countAmountOfTtms : type : includedTtms?.length}})
                    </td>
                </tr>
            }
        </table>
    </div>
    <div class="d-flex flex-column gap-1">
        <button mat-stroked-button (click)="addTtms()" class="w-100 px-0" *ngIf="toAddTtms?.length > 0">
            Items ({{toAddTtms?.length}}) van kaart toevoegen
        </button>
        <button mat-stroked-button color="warn" (click)="removeAllTtms()" class="w-100" *ngIf="includedTtms?.length > 0">
            Alle items ({{includedTtms?.length}}) verwijderen
        </button>
        <button *ngIf="toRemoveTtms?.length" mat-stroked-button color="warn" (click)="removeSelectedTtms()" class="w-100 px-0">
            @if (selectionPolygon?.length > 2) {
                Selectie ({{toRemoveTtms?.length}}) verwijderen
            } @else {
                Items ({{toRemoveTtms?.length}}) van kaart verwijderen
            }
        </button>
    </div>
</div>
